/**
 * Lectura de indicadores Meta Ads homologados (api-rh helpers/meta-ads/definiciones.js).
 * Los reportes nuevos traen `registro_completo` por lead e `indicadores_homologados`;
 * los JSON anteriores a la homologación no, por eso cada función tiene fallback legacy.
 */

export function esLeadCompleto(lead) {
  if (!lead) return false
  if (typeof lead.registro_completo === 'boolean') return lead.registro_completo
  const nombre = lead.nombre_completo ? String(lead.nombre_completo).toUpperCase() : ''
  return !!nombre && !nombre.includes('INCOMPLETO')
}

export function costoONull(gasto, denominador) {
  const d = Number(denominador)
  if (!d || d <= 0) return null
  return Math.round((Number(gasto || 0) / d) * 100) / 100
}

export function indicadoresHomologados(jsonData) {
  return jsonData && jsonData.indicadores_homologados ? jsonData.indicadores_homologados : null
}

export function sucursalHomologada(jsonData, sucursal) {
  const ind = indicadoresHomologados(jsonData)
  if (!ind || !Array.isArray(ind.por_sucursal)) return null
  return ind.por_sucursal.find((s) => s.sucursal === sucursal) || null
}

export const SIN_DATO = 'Sin dato'

function esVacio(valor) {
  return valor === null || valor === undefined || valor === '' || !Number.isFinite(Number(valor))
}

export function formatoMoneda(valor) {
  if (esVacio(valor)) return SIN_DATO
  return Number(valor).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 })
}

export function formatoEntero(valor) {
  if (esVacio(valor)) return SIN_DATO
  return Number(valor).toLocaleString('es-MX', { maximumFractionDigits: 0 })
}

export function formatoPct(valor) {
  if (esVacio(valor)) return SIN_DATO
  return `${Number(valor).toLocaleString('es-MX', { maximumFractionDigits: 2 })} %`
}

export function formatoRoas(valor) {
  if (esVacio(valor)) return SIN_DATO
  return `${Number(valor).toLocaleString('es-MX', { maximumFractionDigits: 2 })}x`
}

/** YYYY-MM-DD en America/Monterrey, desplazado `dias`. */
export function fechaMonterrey(dias) {
  const base = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Monterrey', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(new Date())
  return sumarDias(base, dias || 0)
}

export function sumarDias(fecha, dias) {
  const d = new Date(`${fecha}T12:00:00Z`)
  d.setUTCDate(d.getUTCDate() + dias)
  return d.toISOString().split('T')[0]
}

export function fechaHoraMonterrey(iso) {
  if (!iso) return null
  const d = new Date(iso)
  if (isNaN(d.getTime())) return null
  return d.toLocaleString('es-MX', {
    timeZone: 'America/Monterrey', dateStyle: 'long', timeStyle: 'short',
  })
}
